import React from 'react';

const ErrorIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M15.9999 7.99935C16.7363 7.99935 17.3332 8.5963 17.3332 9.33268V18.666C17.3332 19.4024 16.7363 19.9993 15.9999 19.9993C15.2635 19.9993 14.6666 19.4024 14.6666 18.666V9.33268C14.6666 8.5963 15.2635 7.99935 15.9999 7.99935Z"
      fill="#18222F"
    />
    <path
      d="M15.9999 24.666C16.9204 24.666 17.6666 23.9198 17.6666 22.9993C17.6666 22.0789 16.9204 21.3327 15.9999 21.3327C15.0794 21.3327 14.3332 22.0789 14.3332 22.9993C14.3332 23.9198 15.0794 24.666 15.9999 24.666Z"
      fill="#18222F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1373 6.37063C11.2128 4.10785 13.4945 2.66602 15.9999 2.66602C18.5053 2.66602 20.787 4.10784 21.8625 6.37063L29.1534 21.7098C30.8355 25.2488 28.2548 29.3327 24.3365 29.3327H7.66332C3.74498 29.3327 1.16433 25.2488 2.84642 21.7098L10.1373 6.37063ZM15.9999 5.33268C14.5238 5.33268 13.1794 6.18219 12.5457 7.51539L5.25487 22.8546C4.41383 24.6241 5.70415 26.666 7.66332 26.666H24.3365C26.2957 26.666 27.586 24.6241 26.7449 22.8546L19.4541 7.51539C18.8204 6.18219 17.476 5.33268 15.9999 5.33268Z"
      fill="#18222F"
    />
  </svg>
);

export default ErrorIcon;
